import axios from "@/option/common/dao.js";

window.$glob = {
  url: "",
  params: {},
  query: {},
  header: {},
};

function getGlobParams() {
  var query = window.location.search.substring(1);
  query = query.split("&");
  query.forEach((ele) => {
    var pair = ele.split("=");
    window.$glob.params[pair[0]] = pair[1];
  });
  // 临时适配，后续统一处理window.$glob
  if (!window.$glob.params?.token && window.$glob.params?.sessionKey) {
    window.$glob.params.token = window.$glob.params.sessionKey;
  }

  if(window.$glob.params?.zkIdentification) {
    const zkIdentification =  JSON.parse(
      window.atob(window.decodeURIComponent(window.$glob.params?.zkIdentification))
    )
    // 此处包含solutionId、tenantId、userId
    Object.assign(window.$glob.params, zkIdentification)
  }
}

getGlobParams();


export default axios;
